import React, {useState, useEffect} from 'react';
import { AgGridReact } from "ag-grid-react";
import moment from "moment";
import { SBADrawer } from '../../../UiComponents/SBADrawer';
import { SBAComboBox } from '../../../UiComponents/SBADropDown';
import { SBDatePicker } from '../../../UiComponents/SBDatePicker';
import { getClientStatementAPI } from '../../../../config/apiConfig';
import { sbaAxios } from '../../../utils/sbaAxios';

const ClientStatementStep = ({selectedClientStatement, handleSelectedClientStatement}) => {
    const [showDrawer, setShowDrawer] = useState(false);
    const [csList, setCSList] = useState([]);
    const [selectedCs, setSelectedCs] = useState(null);
    const [startDate, setStartDate] = useState(new Date());
    const [selectedFrequency, setSelectedFrequency] = useState(null);
    const [selectedBatch, setSelectedBatch] = useState(null);
    const [selectedReviewer, setSelectedReviewer] = useState(null);
    const [isInternal, setIsInternal] = useState(false);
    const [isInComposite, setIsInComposite] = useState(false);

    const frequency = [
      {id:0, frequencyName:'Monthly'},
      {id:1, frequencyName:'Quarterly'}
    ];

    const batch = [
      {id:0, batchName:'Batch 1'},
      {id:1, batchName:'Batch 2'},
      {id:2, batchName:'Batch 3'},
      {id:3, batchName:'Batch 99'}
    ];

    const reviewer = [
      {id:0, reviewerName:'Reviewer01'},
      {id:1, reviewerName:'Reviewer02'},
      {id:2, reviewerName:'Reviewer03'}
    ];


    const [gridData, setGridData] = useState([
        {id:1, familyName:'t-family01', clientStatementName:'cs01', selected:false},
        {id:2, familyName:'t-family02', clientStatementName:'cs01', selected:false},
        {id:3, familyName:'t-family03', clientStatementName:'cs01', selected:false},
    ]);
    const colDefs = [
        {headerName:'Family Name', field:'familyName'},
        {headerName:'Client Statement Name', field:'clientStatementName'},
        {
            headerName:'Action', 
            field:'selected',
            cellRenderer: 'agCheckboxCellRenderer',
            cellRendererParams: {
                checkbox: true,
            },
            editable: true,
            width: 100,
        }
    ]

    const fetchCsList = async() => {
      try{
        const list = await sbaAxios({
          url:getClientStatementAPI
        });
        setCSList(list);
      }
      catch(e){
        setCSList([]);
      }
    }

    useEffect(()=>{
        if(selectedClientStatement){
            const updatedGrid = gridData.map((row) => {
                if(row.id === selectedClientStatement.id){
                    row = selectedClientStatement
                }
                return row;
            })
            setGridData(updatedGrid);
        }
    },[selectedClientStatement]);
    
    const onCellValueChanged = (params) => {
        if (params.colDef.field === 'selected' && params.newValue) {
          const updatedData = gridData.map((row) => ({
            ...row,
            selected: row.id === params.data.id,
          }));
    
          handleSelectedClientStatement(params.data);
          setGridData(updatedData);
        }
      };
    return(
      <>
        <div className='container-fluid' style={{paddingTop:0, marginTop:'20px'}}>
            <div className="h4">Add/Select Client Statement</div>
            <div className='row d-flex justify-content-end' style={{ marginRight:'65px' }}>
            <button
                type="submit"
                className="p-sm-btn"
                onClick={() => {
                  setShowDrawer(true);
                  fetchCsList();
                }}
                style={{width:'75px'}}
            >
            Add
            </button>
            </div>
            <div className='row w-100'>
            <div
                className="row my-4"
                style={{ height: "500px", width: "100%" }}
            >
              <div className="row col-12 h-100">
                <div
                  className="ag-theme-alpine"
                  style={{ height: "100%", width: "100%", paddingTop: 0 }}
                >
                  <AgGridReact
                    rowData={gridData}
                    columnDefs={colDefs}
                    rowSelection="single"
                    onCellValueChanged={onCellValueChanged}
                    defaultColDef={{ flex: 1, resizable: true, minWidth: 100 }}
                  />
                </div>
              </div>
            </div>
            </div>
        </div>
        <SBADrawer
          open={showDrawer}
          setOpen={setShowDrawer}
          close={false}
          title={"Add New Client Statement"}
        >
          <div className="row mb-4">
          <div className="col-md-6">
              <div className='d-flex flex-column'>
                <label className="label">Client Statement</label>
                <SBAComboBox
                    data={csList}
                    textField={"ClientStatementName"}
                    valueField={"ClientStatementId"}
                    value={selectedCs}
                    onChange={(e)=>setSelectedCs(e.value)}
                    popupSettings={{ className: "modalDD" }}
                    style={{width:"250px"}}
                ></SBAComboBox>
              </div>
            </div>
            <div className="col-md-6">
              <div className='d-flex flex-column'>
                <label className="label">Start Date</label>
                <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                  {" "}
                  {/* Added flexbox for input and button */}
                  <SBDatePicker
                    className="w-75"
                    value={moment(startDate)}
                    onChange={(newDate) => setStartDate(newDate)}
                    
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="row mb-4">
          <div className="col-md-6">
              <div className='d-flex flex-column'>
                <label className="label">Frequency</label>
                <SBAComboBox
                    data={frequency}
                    textField={"frequencyName"}
                    valueField={"id"}
                    value={selectedFrequency}
                    onChange={(e)=>setSelectedFrequency(e.value)}
                    popupSettings={{ className: "modalDD" }}
                    style={{width:"250px"}}
                ></SBAComboBox>
              </div>
            </div>
            <div className="col-md-6">
              <div className='d-flex flex-column'>
                <label className="label">Batch</label>
                <SBAComboBox
                    data={batch}
                    textField={"batchName"}
                    valueField={"id"}
                    value={selectedBatch}
                    onChange={(e)=>setSelectedBatch(e.value)}
                    popupSettings={{ className: "modalDD" }}
                    style={{width:"250px"}}
                ></SBAComboBox>
              </div>
            </div>
          </div>
          <div className="row mb-4">
          <div className="col-md-6">
              <div className='d-flex flex-column'>
                <label className="label">Reviewer</label>
                <SBAComboBox
                    data={reviewer}
                    textField={"reviewerName"}
                    valueField={"id"}
                    value={selectedReviewer}
                    onChange={(e)=>setSelectedReviewer(e.value)}
                    popupSettings={{ className: "modalDD" }}
                    style={{width:"250px"}}
                ></SBAComboBox>
              </div>
            </div>
          </div>
          <div className="m-1 d-flex justify-content-start mt-2" style={{gap:'20px'}}>
              <p style={{ display: 'flex', alignItems: 'center', marginTop: '25px', gap: '10px' }}>
                  <input
                    type="checkbox"
                    checked={isInternal}
                    onChange={() => setIsInternal(!isInternal)}
                  />
                  <label className="label">Internal</label>
              </p>
              <p style={{ display: 'flex', alignItems: 'center', marginTop: '25px', gap: '10px' }}>
                  <input
                    type="checkbox"
                    checked={isInComposite}
                    onChange={() => setIsInComposite(!isInComposite)}
                  />
                  <label className="label">In Composite</label>
              </p>
          </div>
          <div className="m-1 d-flex justify-content-end mt-2">
            <button className="s-sm-btn mx-1" onClick={()=>setShowDrawer(false)}>Cancel</button>
            <button className="p-sm-btn mx-1" onClick={()=>console.log('Adding new partnership')}>Add</button>
          </div>
        </SBADrawer>
      </>             
    );
};

export default ClientStatementStep;